import { Component, Input, OnInit } from '@angular/core';
import { ProgressReport } from '../../models/progress/progress-report';
import { SignalRService } from 'src/app/services/ui/signalr.service';
import { ProgressReportService } from 'src/app/services/ui/progress-report.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { UserService } from 'src/app/services/user.service';
import { Status } from '../../models/general/status';
import { Error } from 'src/app/shared/models/general/error';
import { DatePipe } from '@angular/common';
@Component({
  selector: 'app-progress-report',
  templateUrl: './progress-report.component.html',
  styleUrls: ['./progress-report.component.scss'],
  providers: [DatePipe],
})
export class ProgressReportComponent implements OnInit {
  @Input() title: string = 'Progress Report';
  @Input() buttonName: string = 'Start Update';
  progressReport: ProgressReport = new ProgressReport();
  progressReportVisible: boolean = false;
  showRunButton: boolean = true;
  showCancelButton: boolean = false;
  errorMessage: string = '';
  processingMessage: string = '';
  textReport: string = '';
  letters: string = '';
  copyTooltip: string = '';
  dateFormat: string = "d MMM yyyy 'at:' H:mm";
  cancelling: boolean = false;
  constructor(
    public signalRService: SignalRService,
    private clipboard: Clipboard,
    private userService: UserService,
    private progressReportService: ProgressReportService,
    private datepipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.progressReportService.isReporting$.subscribe((reporting) => {
      this.showRunButton = !reporting;
      this.showCancelButton = reporting;
    });
    this.copyTooltip = 'Copy to clipboard';
    this.ListenForProgressUpdate();
  }

  ListenForProgressUpdate() {
    this.signalRService.getProgress().subscribe({
      next: (updatedProgress: ProgressReport) => {
        this.errorMessage = '';
        this.processingMessage = '';
        this.cancelling = false;

        this.progressReport = updatedProgress;
        this.progressReportVisible = this.progressReport.total > 0;
        this.processingMessage = this.progressReport.total == -1 ? 'Successfully Cancelled!' : '';

        setTimeout(() => {
          this.processingMessage = '';
        }, 5000);

        this.checkIfReportingIsBusy(this.progressReport);
      },
      error: (error) => {
        //not sure how to get this error report to work
        this.errorMessage = Error.InterpretErrorMessage(error);
      },
    });
  }

  checkIfReportingIsBusy(report: ProgressReport) {
    if (report.percentComplete < 100) {
      this.progressReportService.busyReporting();
    }
    if (report.percentComplete === 100) {
      this.progressReportService.endReporting();
    }
  }

  UpdateAllTradeableBankBalances() {
    this.progressReportVisible = true;
    this.progressReportService.busyReporting();
    this.userService.UpdateAllTradeableBankBalances().subscribe({
      next: (response: Status) => {
        this.processingMessage = `${response.status} Estimated runtime: ${response.estimatedRunningMinutes} min`;
        setTimeout(() => {
          this.processingMessage = '';
        }, 5000);
      },
      error: (error) => {
        this.showRunButton = true;
        this.errorMessage = Error.InterpretErrorMessage(error);
      },
    });
  }

  CancelUpdateBankBalanceProcess() {
    this.cancelling = true;
    this.progressReportVisible = false;
    this.userService.CancelBankBalanceUpdate().subscribe({
      next: (response: Status) => {
        this.processingMessage = response.status;
        setTimeout(() => {}, 5000);
      },
      error: (error) => {
        error.error.ErrorMessage = error.error.status;
        this.errorMessage = Error.InterpretErrorMessage(error);

        setTimeout(() => {
          this.errorMessage = '';
        }, 5000);
      },
    });
  }

  computeWidth(): string {
    let result = `width: ${this.progressReport.percentComplete}%`;
    return result;
  }

  copyReport() {
    let start = this.datepipe.transform(this.progressReport.startTime, this.dateFormat);

    let end = '';
    if (this.progressReport.endTime == null) {
      end = `Report still running... (${this.progressReport.percentComplete}% complete)`;
    } else {
      end = this.datepipe.transform(this.progressReport.endTime, this.dateFormat);
    }

    this.textReport = `Balance Update Report:
    Started: ${start}
    Ended: ${end}
    Total tradeable accounts: ${this.progressReport.total}
    Errors encountered: ${this.progressReport.errors.length}
    \n${this.progressReport.errors.join('\n\n')}`; // Combine report with newlines

    const pending = this.clipboard.beginCopy(this.textReport);
    let remainingAttempts = 3;
    const attempt = () => {
      const result = pending.copy();
      if (!result && --remainingAttempts) {
        setTimeout(attempt);
      } else {
        this.copyTooltip = 'Copied!';
        this.processingMessage = this.copyTooltip;
        setTimeout(() => {
          this.copyTooltip = 'Copy to clipboard';
          this.processingMessage = '';
        }, 5000);
        // Remember to destroy when you're done!
        pending.destroy();
      }
    };
    attempt();
  }
}
